import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from "@angular/core";
import { DomainBaseComponent } from "@/shared/domain-base.component";
import { DomainService } from "@/shared/domain.service";
import { ItemStoryService, StoryEvent } from "@/shared/item-story.service";

@Component({
  selector: "uni-item-story",
  templateUrl: "./item-story.component.html",
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class ItemStoryComponent extends DomainBaseComponent implements OnChanges {
  @Input() itemDetailId: string | null;

  events: StoryEvent[] = [];
  isLoading = false;
  loadError: string | null = null;

  constructor(
    domainService: DomainService,
    private itemStoryService: ItemStoryService,
  ) {
    super(domainService);
  }

  async ngOnChanges(changes: SimpleChanges) {
    if ("itemDetailId" in changes) {
      await this.reload();
    }
  }

  private async reload() {
    if (!this.itemDetailId) {
      this.events = [];
      return;
    }
    this.isLoading = true;
    this.loadError = null;
    try {
      this.events = await this.itemStoryService.buildStory(this.itemDetailId);
    } catch (e: any) {
      this.loadError = e?.message ?? "Failed to load the story for this item.";
      this.events = [];
    } finally {
      this.isLoading = false;
    }
  }
}
